// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"P_TheComp__SR92V"};